<template>
  <div class="table-pager" v-if="pager">
    <label>Items per page</label>
    &nbsp;
    <select class="form-control table-pager__form-control"
            v-if="onChangePageSize"
            v-on:change="onChangePageSizeSelect">
      <option v-for="perPage in pagerData.itemsPerPage"
              v-bind:key="perPage"
              :selected="minItemsPerPage === perPage"
              :value="perPage">{{perPage}}</option>
    </select>
    <ul class="table-pager__list"
        v-if="onPaginate"
        v-bind:key="`${pagerData.page}-${pagerKey}`">
      <li v-for="item in pager.getPages()" v-bind:key="item">
        <span v-if="item === 'start-ellipsis' || item === 'end-ellipsis'">...</span>
        <a class="btn btn-primary"
           v-else-if="pagerData.page != item"
           :page="item"
           @click="paginate(item, $event)"
           href="javascript:;">{{ item }}</a>
        <a class="active btn btn-secondary" v-else>{{ item }}</a>
      </li>
    </ul>
    <div class="table-pager_summary">Showing items {{ pageStart }} to {{ pageEnd }} of {{ pagerData.count }}</div>
  </div>
</template>

<script>

import Pagino from 'pagino'

export default {
  name: 'pager',
  props: {
    pagerData: Object,
    onPaginate: Function,
    onChangePageSize: Function,
    minItemsPerPage: { type: Number, default: 5 }
  },
  data: () => ({
    pager: undefined,
    pages: [],
    pagerKey: 0
  }),
  computed: {
    pageStart () {
      return ((this.pagerData.page - 1) * this.pagerData.pageSize) + 1
    },
    pageEnd () {
      return Math.min(this.pagerData.page * this.pagerData.pageSize, this.pagerData.count)
    }
  },
  updated () {
    this.pager.setPage(this.pagerData.page)
    this.pager.setCount(this.pagerData.pagesCount)
    this.pager.showFirst = this.pagerData.count > this.pagerData.pageSize
    this.pager.showPrevious = this.pagerData.count > this.pagerData.pageSize
    this.pager.showNext = this.pagerData.count > this.pagerData.pageSize
    this.pager.showLast = this.pagerData.count > this.pagerData.pageSize
  },
  mounted () {
    this.pager = new Pagino()
  },
  methods: {
    forceRerender () {
      this.pagerKey = this.pagerKey + 1
    },
    paginate (pageItem, $evt) {
      if (isNaN(pageItem)) {
        this.pager[pageItem]()
      } else {
        this.pager.setPage(pageItem)
      }

      if (this.onPaginate) {
        this.onPaginate(this.pager.page, this.pager.count)
      }
    },
    onChangePageSizeSelect ($evt) {
      if (this.onChangePageSize) {
        this.onChangePageSize(parseInt($evt.target.value, 10))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-pager {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: baseline;

  &_summary {
    font-weight: bold;
  }

  &__list li {
    display: inline;
    margin-right: 1rem;

    a {
      text-decoration: none;
      display: inline-block;
      border-radius: 3px;
      padding: 5px 10px;
      text-transform: capitalize;

      &:hover {
        text-decoration: underline;
      }

      &.active {
        background: #fff;

        &:hover {
          text-decoration: none;
          cursor: default;
        }
      }
    }
    > * {
      margin-top: 2px;
    }
  }

  &__form-control {
    width: 8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pager/pager.vue